import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  Button,
  Heading,
  HStack,
  Link,
  Spinner,
  useClipboard,
  VStack,
} from '@chakra-ui/react';
import { CopyIcon } from '@chakra-ui/icons';

import { PluginProps } from '../../Plugin';
import { useGetMeWithInfobipQuery } from '../../../../../../generated/graphqlModels';

const CopyButton: React.FC<{ name: string; value: string }> = (props) => {
  const { name, value } = props;
  const { onCopy, hasCopied } = useClipboard(value);

  return (
    <Button
      onClick={onCopy}
      isDisabled={hasCopied}
      rightIcon={<CopyIcon />}
      size="sm"
    >
      {hasCopied ? 'Copied' : `Copy ${name}`}
    </Button>
  );
};

const InfobipPortalEmbedBlock: React.FC<PluginProps> = (props) => {
  const useOldBlock = (props.content as any)?.use_old_block;
  if (useOldBlock) {
    return <OldInfobipPortalEmbedBlock {...props} />;
  }
  return <NewInfobipPortalEmbedBlock {...props} />;
};

const NewInfobipPortalEmbedBlock: React.FC<PluginProps> = (props) => {
  const { data, loading, error } = useGetMeWithInfobipQuery();
  const location = useLocation();

  // function to get query parameter value by name
  const getQueryParam = (name: string) => {
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get(name);
  };

  const studyGroupId = getQueryParam('study-group-id');

  const infobipHref = studyGroupId
    ? `https://lab.stemi.education/idp/infobip/start?study-group-id=${studyGroupId}`
    : 'https://lab.stemi.education/idp/infobip/start';

  return (
    <VStack>
      <VStack spacing="2" bg="gray.200" p="4" borderRadius="md">
        <Heading size="lg">
          <Link isExternal href={infobipHref}>
            Open Infobip Platform
          </Link>
        </Heading>
        <Heading size="sm">Infobip Answers</Heading>
      </VStack>
    </VStack>
  );
};

const OldInfobipPortalEmbedBlock: React.FC<PluginProps> = (props) => {
  const { data, loading, error } = useGetMeWithInfobipQuery();

  return (
    <VStack>
      <VStack spacing="2" bg="gray.200" p="4" borderRadius="md">
        <Heading size="lg">
          <Link isExternal href="https://portal.infobip.com/">
            Open Infobip Platform
          </Link>
        </Heading>

        {loading && <Spinner />}
        {error && <Heading size="sm">Error loading infobip data</Heading>}
        {!loading &&
          !error &&
          data &&
          (data.me.infobipDirect?.infobipState !== 'infobip_complete' ? (
            <Heading size="md">
              Your infobip account isn't fully completed, currently [
              {data.me.infobipDirect?.infobipState || 'Not created'}]
            </Heading>
          ) : data.me.infobipDirect?.infobipPassword ? (
            <HStack>
              <CopyButton
                name="username"
                value={data.me.infobipDirect.infobipUsername}
              />
              <CopyButton
                name="password"
                value={data.me.infobipDirect.infobipPassword}
              />
            </HStack>
          ) : (
            <Heading size="sm" color="red.300">
              You don't have an infobip user
            </Heading>
          ))}
      </VStack>
    </VStack>
  );
};

export default InfobipPortalEmbedBlock;
